import axios from "axios";
import { apiServices } from "../../../core/utilities/ApiServices";

export const LIKE_EMAIL_FREQUENCIES = ["daily", "weekly", "never"] as const;
export type LikeEmailFrequency = typeof LIKE_EMAIL_FREQUENCIES[number];

const SIGNED_IN_PATH = "/incoming-like-email-preference";
const PUBLIC_PATH = "/incoming-like-email-preference/public";
const PUBLIC_TOKEN_HEADER = "X-Unjabbed-Preference-Token";

// Public email links must never inherit a signed-in member's Authorization
// header or the signed-in session-expiry redirect behavior.
const publicPreferenceApi = axios.create({
	baseURL: process.env.REACT_APP_UNJABBED,
	headers: { "x-client-platform": "web" },
});

const readFrequency = (data: unknown): LikeEmailFrequency => {
	const frequency = String((data as { frequency?: unknown })?.frequency || "")
		.trim()
		.toLowerCase();
	if (!LIKE_EMAIL_FREQUENCIES.includes(frequency as LikeEmailFrequency)) {
		throw new Error("Invalid Likes You email preference response");
	}
	return frequency as LikeEmailFrequency;
};

export const incomingLikeEmailPreferenceApi = {
	async getSignedIn(): Promise<LikeEmailFrequency> {
		const response = await apiServices.get(SIGNED_IN_PATH);
		return readFrequency(response.data);
	},

	async saveSignedIn(frequency: LikeEmailFrequency): Promise<LikeEmailFrequency> {
		const response = await apiServices.put(SIGNED_IN_PATH, { frequency });
		return readFrequency(response.data);
	},

	async getPublic(token: string): Promise<LikeEmailFrequency> {
		const response = await publicPreferenceApi.get(PUBLIC_PATH, {
			headers: { [PUBLIC_TOKEN_HEADER]: token },
		});
		return readFrequency(response.data);
	},

	async savePublic(token: string, frequency: LikeEmailFrequency): Promise<LikeEmailFrequency> {
		const response = await publicPreferenceApi.put(
			PUBLIC_PATH,
			{ frequency },
			{ headers: { [PUBLIC_TOKEN_HEADER]: token } }
		);
		return readFrequency(response.data);
	},
};
